import React from "react";
import { message, Modal, Spin } from "antd";
import { useMount, useSearchParam } from "react-use";
import { errorMessage, isTrue } from "service/service";
import { authLogin, login } from "service/auth";
import { useAtomValue } from "jotai";
import { loginModeAtom, loginUnifySetAtom } from "service/stores/SettingsStore";
import Storage from "utils/Storage";
import LoginComponent from "../components/LoginComponent";
import useRequestFn from "../../../utils/useRequestFn";
import { FormFields } from "../components/LoginComponent/components/AccountMode";

export default function Login() {
    const loginMode = useAtomValue(loginModeAtom);
    const loginUnifySet = useAtomValue(loginUnifySetAtom);

    const code = useSearchParam("code");

    useMount(() => {
        Storage.clear();

        // 统一身份认证返回
        if (isTrue(loginMode.unifyAuthLogin) && code) {
            return loginWithCode(code);
        }

        // 如果不允许常规登录, 直接跳转到统一身份认证
        if (!isTrue(loginMode.normalAuthLogin) && !code) {
            window.location.href = loginUnifySet.ssoUrl;
        }
    });

    const [onFinish, { loading }] = useRequestFn(async (data: FormFields) => {
        try {
            await login(data.loginName, data.pwd);
            onLoginSuccess();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    const [loginWithCode] = useRequestFn(async (code: string) => {
        try {
            await authLogin(code);
            onLoginSuccess();
        } catch (e) {
            Modal.error({
                content: errorMessage(e, "登录失败, 请重试"),
                onOk: () => {
                    Storage.clear();
                    window.location.href = `https://sso.dufe.edu.cn/auth/user/logout?client_id=${loginUnifySet.clientId}`;
                },
                okText: "重新登录"
            });
        }
    });

    function onLoginSuccess() {
        window.location.href = "/";
    }

    if (!isTrue(loginMode.normalAuthLogin))
        return <Spin spinning>正在登录...</Spin>;
    return <LoginComponent onSubmit={onFinish} loading={loading} />;
}
